module.exports = __webpack_public_path__ + "static/CaslonGraD.49742e47.ttf";


//////////////////
// WEBPACK FOOTER
// ./public/fonts/CaslonGraD.ttf
// module id = 630
// module chunks = 168707334958949